import { UPDATE_THIRD_PARTY_SUBJECT } from '../constants/MethodNames';
import { callingAPIMethodWithQueue } from '../utils/hsCallingUtils';
export default function updateThirdPartySubject(subject) {
  return callingAPIMethodWithQueue(UPDATE_THIRD_PARTY_SUBJECT, subject);
}